import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=2a01eec2&"
import script from "./BaseHeading.vue?vue&type=script&lang=ts&"
export * from "./BaseHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports